import { CbBankFieldTypes } from 'cbbank/inquiry/fields';

type CbBankCompanySearchSectionFieldTypes =
  CbBankFieldTypes['companyDataPage']['companySearchSection'];

export const mapCbBankCompanySearch = (values: CbBankCompanySearchSectionFieldTypes) => ({
  crefo_id: values.crefoId,
});
